import {Agent as HttpsAgent} from 'https';
import {Agent as HttpAgent} from 'http';

export default function ({ $config, $axios, route, app }) {

    // Reuse HTTP connections across multiple requests
    $axios.defaults.httpsAgent = new HttpsAgent({
        keepAlive: true,
        keepAliveMsecs: 5000,
        maxSockets: 5,
        maxTotalSockets: 10,
        maxFreeSockets: 5,
        timeout: 15000,
    });
    $axios.defaults.httpAgent = new HttpAgent({
        keepAlive: true,
        keepAliveMsecs: 5000,
        maxSockets: 5,
        maxTotalSockets: 10,
        maxFreeSockets: 5,
        timeout: 15000,
    });

    $axios.onRequest(config => {

        // We can force the specification of the guest api token to improve caching
        const isForcingGuestRequest = config.params?._guest ?? false;
        if (config.params?._guest !== undefined) {
            delete config.params._guest;
        }

        // Add the generic auth token of the frontend app, if no user auth token is specified, i.e., the user is not authenticated
        if (!config.headers.common['Authorization'] || isForcingGuestRequest) {
            config.headers['Authorization'] = $config.apiAuthToken;
        } else if (config.headers['Authorization'] === $config.apiAuthToken && app.$auth?.token) {
            config.headers['Authorization'] = app.$auth?.token;
        }

        // Forward debug flags
        if (route.query.debug) {
            config.params = config.params ?? {};
            config.params.debug = route.query.debug;
        }

        // Set the Origin header for SSR requests, so it matches CSR requests (where it gets automatically set by the browser) for improved API HTTP caching
        if (process.server) {
            $axios.setHeader('Origin', $config.appUrl)
        }

        // Add the user's language preference
        if (app.i18n && app.i18n.locale) {
            const locale = app.i18n.locales.find(locale => locale.code === app.i18n.locale);
            if (locale && locale.iso) {
                $axios.setHeader('Accept-Language', locale.iso)
            }
        }

        // Add the X-Socket-ID header when we are using WebSockets to benefit from the broadcast to others feature
        // As this is only relevant for writing HTTP methods, we do not add this for GET and OPTION calls to not influence caching performance
        if (app.$echo && !['get', 'options'].includes(config.method.toLowerCase())) {
            const connectionId = app.$echo.getConnectionId();
            if (connectionId) {
                $axios.setHeader('X-Socket-ID', connectionId)
            }
        }
    })

    $axios.onError(error => {
        const code = parseInt(error.response && error.response.status)

        let loginPath = '/login';

        // We auto logout the user if his token expired
        // This can only be done on the client side
        if (code === 401 && process.client && typeof window !== 'undefined' && route.path !== loginPath && error.response.config.url !== `${$config.apiUrl}/v1/auth/logout`) {

            // We redirect the user to the login even when an error occurred to not end up in an infinite loop
            app.$auth.logout().finally(() => {
                if ($config.isSpoferanDomain) {
                    app.router.push({path: loginPath, query: {redirect: route.path}})
                } else {
                    window.location.href = `${$config.spoferanUrl}${loginPath}?redirect=${encodeURIComponent($config.appUrl + route.path)}`;
                }
            });

        } else if ($axios.isCancel(error)) {
            return Promise.reject(null);
        } else {
            const errorBody = error.response?.data ?? {};

            // Reject with a custom controlled error response as otherwise we run into a "Maximum call stack size exceeded" error on hydration for large errors
            return Promise.reject({
                ...errorBody,
                statusCode: error.response?.status ?? 500,
                message: error.response?.data?.display_message ?? error.response?.data?.message
            });
        }
    })
}